import { Login } from './pages/public';
import { DashboardPage } from './pages';
import { JobsPage } from './pages/Jobs';
import { SystemPage } from './pages/System';
import { AlertsPage } from './pages/Alerts';
import { HistoryPage } from './pages/History';
import { Invite } from './pages/public/invite';
import { AppliancesPage } from './pages/Appliances';
import { LiveViewPage } from './pages/LiveView';
import { ErrorPage } from './pages/Alerts/error';
import { CustomersPage } from './pages/Customers';
import { Register } from './pages/public/register';
import NotFoundPage from './pages/public/NotFound';
import { InstallersPage } from './pages/Installers';
import AuthGuard from './components/shared/AuthGuard';
import { SettingsLayout } from './layouts/SettingsLayout';
import { UsersTab } from './components/Settings/UsersTab';
import { ActionPage } from './pages/System/action/action';
import { TariffTab } from './components/Settings/TariffTab';
import { ResetPassword } from './pages/public/resetPassword';
import { GeneralTab } from './components/Settings/GeneralTab';
import { BillingTab } from './components/Settings/BillingTab';
import AuthenticatedLayout from './layouts/AuthenticatedLayout';
import { SecurityTab } from './components/Settings/SecurityTab';
import { BrandingTab } from './components/Settings/BrandingTab';
import { HardwareTypesPage } from './pages/System/appliance/types';
import { JobCategoriesPage } from './pages/System/job/categories';
import { InstallerTab } from './components/Settings/InstallerTab';
import { TemplatesTab } from './components/Settings/TemplatesTab';
import { ApplianceModelsPage } from './pages/System/appliance/models';
import { DataPointsPage } from './pages/System/datapoint/dataPoints';
import { ForgottenPassword } from './pages/public/forgottenPassword';
import { UnauthenticatedLayout } from './layouts/UnauthenticatedLayout';
import { ActionProfilesPage } from './pages/System/action/actionProfiles';
import { DataPointOptionsPage } from './pages/System/datapoint/dataPointOptions';
import { ApplianceManufacturersPage } from './pages/System/appliance/manufacturers';
import { DataPointProfilesPage } from './pages/System/datapoint/dataPointProfiles';
import { DataPointFunctionsPage } from './pages/System/datapoint/dataPointFunctions';
import { ActionTransformationsPage } from './pages/System/action/actionTransformations';
import { GlobalApplianceModelFilterProvider } from './contexts/GlobalHardwareFilterContext';
import { DataPointProfileAddEditPage } from './pages/System/datapoint/dataPointProfileAddEdit';
import { DataPointTransformationsPage } from './pages/System/datapoint/dataPointTransformations';
import { DevicesPage } from './pages/Devices';
import WeatherComp from './pages/WeatherComp';
import { DataPointFinderPage } from './pages/System/utils/datapointFinder';
import path from 'path';
import FaultPage from './pages/Fault';
import FaultDetailsPage from './pages/Fault/faultDetails';
import { FaultDefinitionsPage } from './pages/System/fault/faultDefinitions';
import FaultDefinitionAddEditPage from './pages/System/fault/faultDefinitionAddEdit';
import { elements } from 'chart.js';
import { FaultCausesPage } from './pages/System/fault/faultCauses';
import { FaultActionsPage } from './pages/System/fault/faultActions';
import { ConnectorsTab } from './components/Settings/ConnectorsTab';
import { OrbitPage } from './pages/Orbit';

const routes = [
  {
    path: '',
    element: <AuthenticatedLayout />,
    children: [
      {
        index: true,
        element: (
          <AuthGuard component={<LiveViewPage />} requiredRole="customer" />
        ),
      },
      {
        path: 'weather-comp',
        element: (
          <AuthGuard component={<WeatherComp />} requiredRole="installer" />
        ),
      },
      {
        path: 'history',
        element: (
          <AuthGuard component={<HistoryPage />} requiredRole="customer" />
        ),
      },
      {
        path: 'alerts',
        element: (
          <AuthGuard component={<AlertsPage />} requiredRole="customer" />
        ),
      },
      {
        path: 'appliances',
        element: (
          <AuthGuard component={<AppliancesPage />} requiredRole="customer" />
        ),
      },
      {
        path: 'devices',
        element: (
          <AuthGuard component={<DevicesPage />} requiredRole="customer" />
        ),
      },
      {
        path: 'faults',
        children: [
          {
            index: true,
            element: (
              <AuthGuard
                component={<FaultPage />}
                requiredRole={['installer', 'installerActingAsCustomer']}
              />
            ),
          },
          {
            path: ':faultDefinitionId',
            element: (
              <AuthGuard
                component={<FaultDetailsPage />}
                requiredRole={['installer', 'installerActingAsCustomer']}
              />
            ),
          },
        ],
      },
      {
        path: 'settings',
        element: (
          <AuthGuard component={<SettingsLayout />} requiredRole="customer" />
        ),
        children: [
          {
            index: true,
            element: <GeneralTab />,
          },
          {
            path: 'tariffs',
            element: <TariffTab />,
          },
          {
            path: 'security',
            element: <SecurityTab />,
          },
          {
            path: 'users',
            element: <UsersTab />,
          },
          {
            path: 'branding',
            element: <BrandingTab />,
          },
          {
            path: 'billing',
            element: <BillingTab />,
          },
          {
            path: 'installer',
            element: <InstallerTab />,
          },
          {
            path: 'templates',
            element: <TemplatesTab />,
          },
          {
            path: 'connectors',
            element: <ConnectorsTab />,
          },
        ],
      },
      {
        path: 'dashboard',
        element: (
          <AuthGuard
            component={<DashboardPage />}
            requiredRole={['installer', 'superadmin']}
          />
        ),
      },
      {
        path: 'error',
        element: (
          <AuthGuard
            component={<ErrorPage />}
            requiredRole={['installer', 'superadmin']}
          />
        ),
      },
      {
        path: 'jobs',
        element: (
          <AuthGuard
            component={<JobsPage />}
            requiredRole={['installer', 'superadmin']}
          />
        ),
      },
      {
        path: 'customers',
        element: (
          <AuthGuard
            component={<CustomersPage />}
            requiredRole={['installer', 'superadmin']}
          />
        ),
      },
      {
        path: 'installers',
        element: (
          <AuthGuard component={<InstallersPage />} requiredRole="superadmin" />
        ),
      },
      {
        path: 'orbit',
        element: (
          <AuthGuard component={<OrbitPage />} requiredRole="installer" requiresFeature="orbit" />
        ),
      },
      {
        path: 'system',
        element: (
          <AuthGuard
            component={<GlobalApplianceModelFilterProvider />}
            requiredRole="superadmin"
          />
        ),
        children: [
          {
            index: true,
            element: <SystemPage />,
          },
          {
            path: 'hardware',
            children: [
              {
                path: 'types',
                element: <HardwareTypesPage />,
              },
              {
                path: 'models',
                element: <ApplianceModelsPage />,
              },
              {
                path: 'manufacturers',
                element: <ApplianceManufacturersPage />,
              },
            ],
          },
          {
            path: 'job',
            children: [
              {
                path: 'categories',
                element: <JobCategoriesPage />,
              },
            ],
          },
          {
            path: 'action',
            children: [
              {
                index: true,
                element: <ActionPage />,
              },
              {
                path: 'profiles',
                element: <ActionProfilesPage />,
              },
              {
                path: 'transformations',
                element: <ActionTransformationsPage />,
              },
            ],
          },
          {
            path: 'datapoint',
            children: [
              {
                index: true,
                element: <DataPointsPage />,
              },
              {
                path: 'options',
                element: <DataPointOptionsPage />,
              },
              {
                path: 'functions',
                element: <DataPointFunctionsPage />,
              },
              {
                path: 'transformations',
                element: <DataPointTransformationsPage />,
              },
              {
                path: 'profiles',
                children: [
                  {
                    index: true,
                    element: <DataPointProfilesPage />,
                  },
                  {
                    path: 'add',
                    element: <DataPointProfileAddEditPage />,
                  },
                  {
                    path: ':dataPointProfileId',
                    element: <DataPointProfileAddEditPage />,
                  },
                ],
              },
            ],
          },
          {
            path: 'utils',
            children: [
              {
                index: true,
                element: <DataPointFinderPage />,
              },
            ],
          },
          {
            path: 'fault',
            children: [
              {
                index: true,
                element: <FaultDefinitionsPage />,
              },
              {
                path: 'actions',
                element: <FaultActionsPage />,
              },
              {
                path: 'causes',
                element: <FaultCausesPage />,
              },
              {
                path: ':faultDefinitionId',
                element: <FaultDefinitionAddEditPage />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'login',
    element: <UnauthenticatedLayout />,
    children: [
      {
        index: true,
        element: <Login />,
      },
    ],
  },
  {
    path: 'forgotten-password',
    element: <UnauthenticatedLayout />,
    children: [
      {
        index: true,
        element: <ForgottenPassword />,
      },
    ],
  },
  {
    path: 'reset-password',
    element: <UnauthenticatedLayout />,
    children: [
      {
        index: true,
        element: <ResetPassword />,
      },
    ],
  },
  {
    path: 'invite',
    element: <UnauthenticatedLayout />,
    children: [
      {
        index: true,
        element: <Invite />,
      },
    ],
  },
  {
    path: 'register',
    element: <UnauthenticatedLayout />,
    children: [
      {
        index: true,
        element: <Register />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
